import React from "react";

const PagePopopCloseButton = ({ close, isDisabled = false }) => {

  return (
    <button className="modal-window__close" onClick={close} disabled={isDisabled}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 4L4 12M4 4L12 12"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default PagePopopCloseButton;
